import Layout from "@/components/elements/Layout";
import Spinner from "@/components/Spinner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { sendDontSellRequest } from "@/services/api/User";
import { useRouter } from "next/router";
import { useState } from "react";
import toast from "react-hot-toast";

export default function DontSellMyInfo() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [linkedInProfile, setLinkedInProfile] = useState("");

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    setLoading(true);

    try {
      const payload = {
        first_name: firstName,
        last_name: lastName,
        email,
        phone_number: phoneNumber,
        linkedin_url: linkedInProfile,
      };

      await sendDontSellRequest(payload);
      toast.success("Your request has successfully sent!");
      router.reload();
    } catch (error) {
      toast.error("An error occured. Please try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title={"Do Not Sell My Info"}>
      <div className='max-w-6xl px-4 mx-auto 2xl:max-w-7xl'>
        <h1 className='pt-8 text-6xl font-bold leading-tight text-white font-display'>
          Do Not Sell My Info
        </h1>
        <p className='max-w-screen-md mb-2 text-white text-opacity-80'>
          We need your name and email address in order to process your request
          and safeguard your data. We will use the data gathered here only to
          process your request and for record-keeping.
        </p>
        <p className='max-w-screen-md text-white text-opacity-80'>
          You will receive an email to verify your address. Follow the
          instructions you will receive to complete processing of your request.
        </p>
        <div className='max-w-screen-md py-8'>
          <form
            onSubmit={handleSubmit}
            className='flex flex-col max-w-screen-md gap-8'
          >
            <div className='flex flex-col gap-2'>
              <Label className='text-xs' htmlFor='first_name'>
                First Name
              </Label>
              <Input
                type='text'
                id='first_name'
                required
                onChange={(evt) => setFirstName(evt.target.value)}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <Label className='text-xs' htmlFor='last_name'>
                Last Name
              </Label>
              <Input
                type='text'
                id='last_name'
                required
                onChange={(evt) => setLastName(evt.target.value)}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <Label className='text-xs' htmlFor='email'>
                Email Address
              </Label>
              <Input
                type='email'
                id='email'
                required
                onChange={(evt) => setEmail(evt.target.value)}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <Label className='text-xs' htmlFor='phone_number'>
                Phone Number
              </Label>
              <Input
                type='text'
                id='phone_number'
                required
                onChange={(evt) => setPhoneNumber(evt.target.value)}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <Label className='text-xs' htmlFor='linkedin_username'>
                LinkedIn Profle Username
              </Label>
              <Input
                type='text'
                id='linkedin_username'
                required
                onChange={(evt) => setLinkedInProfile(evt.target.value)}
              />
            </div>
            <button type='submit' className='btn-gradation'>
              {loading && <Spinner />}
              {loading ? "Sending Request ..." : "Send Request"}
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
}
